import { useEffect, useState } from 'react'

import { getRequestConnectedDocFlowsListApi } from '../../../../../api'
import { EMPTY_OBJECT } from '../../../../../constants/common'
import { REQUEST_DOC_FLOWS_ENTITY } from '../../../../../constants/entity'
import { useDebouncedSearch, useSelection } from '../../../../../hooks'
import { getEmptyPermanentFilters } from '../../../../../utils/filter'
import {
  getEntityTabFilterStateApi,
  updateEntityTabTableConfig,
} from '../../../../EntityTab'
import { useAsyncTable } from '../../../../Table'
import { REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_TIMEOUT } from '../../RequestProfileTabDocFlows.constants'
import {
  getRequestProfileTabDocFlowsSearchFilters,
  isRequestProfileTabDocFlowsSearchActive,
} from '../../RequestProfileTabDocFlows.utils'

export function useRequestProfileTabDocFlowsTable({
  containerRef,
  isPreview,
  requestId,
}) {
  const [isConfigOpen, setConfigOpen] = useState(false)

  const { debouncedSearch, handleChangeSearch, handleClearSearch, search } =
    useDebouncedSearch(REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_TIMEOUT)

  const searchQuery = debouncedSearch.trim()

  const asyncTable = useAsyncTable({
    containerRef,
    entity: REQUEST_DOC_FLOWS_ENTITY,
    extraFilters: getRequestProfileTabDocFlowsSearchFilters(searchQuery),
    filterStateApi: getEntityTabFilterStateApi({
      entityPlural: REQUEST_DOC_FLOWS_ENTITY.plural,
      objectId: requestId,
    }),
    getPermanentFilters: getEmptyPermanentFilters,
    isLocalPagination: isPreview,
    listApi: getRequestConnectedDocFlowsListApi(requestId),
    withoutSubMenu: true,
  })

  const selection = useSelection({
    data: asyncTable.items,
    pagination: asyncTable.pagination,
  })

  useEffect(() => {
    selection.handleCleanSelection()
  }, [asyncTable.filterValues, requestId, searchQuery])

  async function handleApplyConfig(obj = EMPTY_OBJECT) {
    return updateEntityTabTableConfig(
      { columns: asyncTable.columns, view: asyncTable.view, ...obj },
      REQUEST_DOC_FLOWS_ENTITY.plural
    )
  }

  async function handleDensityChange() {
    asyncTable.handleSetDense(!asyncTable.isDense)

    return handleApplyConfig({ show_extra_info: !asyncTable.isDense })
  }

  function handleConfigOpen() {
    setConfigOpen(true)
  }

  return {
    ...asyncTable,
    ...selection,
    handleApplyConfig,
    handleChangeSearch,
    handleClearSearch,
    handleConfigOpen,
    handleDensityChange,
    isConfigOpen,
    isSearchActive: isRequestProfileTabDocFlowsSearchActive(searchQuery),
    search,
    setConfigOpen,
  }
}
